import { combineReducers } from "redux";
import {
    MASTER_HARGA_GET_ERROR,
    MASTER_HARGA_GET_LOADING,
    MASTER_HARGA_GET_SUCCESS,
    FORM_MASTER_HARGA,
    FORM_MASTER_HARGA_MULTI,
    FORM_MASTER_HARGA_MULTI_EDIT,
    FORM_MASTER_HARGA_EDIT_PER_CONTAINER,
    GET_ACTIVE_MASTER_HARGA,
    FORM_MASTER_HARGA_MULTI_DELETE,
    GET_MASTER_HARGA_DETAIL,
} from "../actions/masterHargaAction";

const MASTER_HARGA_INITIAL = {
    count: 0,
    data: [],
};

const masterHargaGetLoading = (state = false, action) => {
    switch (action.type) {
        case MASTER_HARGA_GET_LOADING:
            return action.getLoading;
        default:
            return state;
    }
};

const masterHargaGetError = (state = false, action) => {
    switch (action.type) {
        case MASTER_HARGA_GET_ERROR:
            return action.getError;
        default:
            return state;
    }
};

const masterHargaGetSuccess = (state = false, action) => {
    switch (action.type) {
        case MASTER_HARGA_GET_SUCCESS:
            return action.getSuccess;
        default:
            return state;
    }
};

const masterHargaGet = (state = MASTER_HARGA_INITIAL, action) => {
    switch (action.type) {
        case MASTER_HARGA_GET_SUCCESS:
            return action.dataMasterHarga;
        default:
            return state;
    }
};

const masterHargaForm = (
    state = { open: false, code: 1, status: "", data: [], message: "" },
    action
) => {
    switch (action.type) {
        case FORM_MASTER_HARGA:
            return {
                open: action.open,
                code: action.code,
                status: action.status,
                data: action.data,
                messagge: action.message,
            };
        default:
            return state;
    }
};

const masterHargaFormMulti = (
    state = { loading: false, success: false, error: false, data: null, message: "" },
    action
) => {
    switch (action.type) {
        case FORM_MASTER_HARGA_MULTI:
            return {
                loading: action.loading,
                success: action.success,
                error: action.error,
                data: action.data,
                message: action.message,
            };
        default:
            return state;
    }
};

const masterHargaFormMultiEdit = (
    state = { loading: false, success: false, error: false, data: null, message: "" },
    action
) => {
    switch (action.type) {
        case FORM_MASTER_HARGA_MULTI_EDIT:
            return {
                loading: action.loading,
                success: action.success,
                error: action.error,
                data: action.data,
                message: action.message,
            };
        default:
            return state;
    }
};

const masterHargaFormEditPerContainer = (
    state = { loading: false, success: false, error: false, data: null, message: "" },
    action
) => {
    switch (action.type) {
        case FORM_MASTER_HARGA_EDIT_PER_CONTAINER:
            return {
                loading: action.loading,
                success: action.success,
                error: action.error,
                data: action.data,
                message: action.message,
            };
        default:
            return state;
    }
};

const masterHargaGetDetail = (
    state = { loading: false, success: false, error: false, data: null, message: "" },
    action
) => {
    switch (action.type) {
        case GET_MASTER_HARGA_DETAIL:
            return {
                loading: action.loading,
                success: action.success,
                error: action.error,
                data: action.data,
                message: action.message,
            };
        default:
            return state;
    }
};

const masterHargaDeleteMulti = (
    state = { loading: false, success: false, error: false, data: null, message: "" },
    action
) => {
    switch (action.type) {
        case FORM_MASTER_HARGA_MULTI_DELETE:
            return {
                loading: action.loading,
                success: action.success,
                error: action.error,
                data: action.data,
                message: action.message,
            };
        default:
            return state;
    }
};

const masterHargaGetActive = (state = { loading: false, code: 0, data: [] }, action) => {
    switch (action.type) {
        case GET_ACTIVE_MASTER_HARGA:
            return {
                loading: action.loading,
                code: action.code,
                data: action.data,
            };
        default:
            return state;
    }
};

const masterHargaReducer = combineReducers({
    masterHargaGetLoading,
    masterHargaGetError,
    masterHargaGetSuccess,
    masterHargaGet,
    masterHargaForm,
    masterHargaFormMulti,
    masterHargaFormMultiEdit,
    masterHargaFormEditPerContainer,
    masterHargaDeleteMulti,
    masterHargaGetActive,
    masterHargaGetDetail,
});

export default masterHargaReducer;
